<template>
  <button class="c-book__arrow">
    <span class="icon">
      <arrow-icon />
    </span>
  </button>
</template>

<script>
import LeftRightArrow from '@/assets/svg/LeftRightArrow.vue'

export default {
  name: 'BookPageArrow',

  components: {
    'arrow-icon': LeftRightArrow,
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/_mixin.scss';
.c-book__arrow {
  @include btnReset();

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10rem 1.65rem;
  pointer-events: initial;
  cursor: pointer;

  @include a11yOutline();

  &:hover {
    .c-book__arrow-svg {
      transform: scale(1.3);
    }
  }

  .icon {
    width: 4.375rem;
    height: 4.375rem;
    border-radius: 50%;
    background-color: $very-light-pink;

    .c-book__arrow-svg {
      transition: transform 0.3s;
    }
  }
}
.c-book__arrow.prev {
  left: 3%;
  .icon {
    transform: rotate(180deg);
  }
}
.c-book__arrow.next {
  right: 3%;
}
</style>
